module.exports = __webpack_public_path__ + "img/decast-navbar-logo.967b378b.svg";